let RESIZE_ACTION = false;

const getComponentRatio = (componentType: string, startHeight: number, startWidth: number, height: number, width: number) => {
  const fixedRatio = ["WIDGET_QR_CODE", "WIDGET_TEXT", "WIDGET_READ", "WIDGET_STOPWATCH", "WIDGET_EVENT_COUNTDOWN", "WIDGET_TIMETABLE", "WIDGET_HYPERLINK", "WIDGET_MIND_MAP", "WIDGET_IMAGE"]; // fixed ratio for top-left / top-right / bottom-right / bottom-left
  const specialRatio = ["WIDGET_TIMER", "WIDGET_CLOCK", "WIDGET_CALENDAR", "WIDGET_HYPERLINK", "WIDGET_TIMETABLE", "WIDGET_MIND_MAP"]; // square
  const arbitraryRatio = ["WIDGET_RANDOM_NAME", "WIDGET_IMAGE", "WIDGET_EMBED", "WIDGET_GROUP_MAKER", "WIDGET_WEBCAM", "WIDGET_VIDEO_TIMELINE"];
  const excludeType = ["WIDGET_GROUP_MAKER", "WIDGET_TEXT", "WIDGET_READ", "WIDGET_WORKS"];
  let ratio = 0;

  if (fixedRatio.includes(componentType)) {
    ratio = startHeight / startWidth;
  } else if (specialRatio.includes(componentType)) {
    const _ratio = height / width;
    if (componentType === "WIDGET_TIMER") {
      if (_ratio <= 0.375) ratio = 0.375;
      else if (_ratio >= 1) ratio = 1;
      else ratio = 0;
    } else if (componentType === "WIDGET_CLOCK") {
      if (_ratio <= 0.4) ratio = 0.4;
      else if (_ratio >= 1.25) ratio = 1.25;
      else ratio = 0;
    } else if (componentType === "WIDGET_CALENDAR") {
      if (_ratio <= 0.667) ratio = 0.667;
      else if (_ratio >= 1.42) ratio = 1.42;
      else ratio = 0;
    }
  } else {
    // arbitraryRatio or exclude
    ratio = 0;
  }

  return ratio;
}

export const resizeCalculate = (direction: "top" | "right" | "bottom" | "left" | "top-left" | "top-right" | "bottom-right" | "bottom-left", startWidth: number, startHeight: number, startOffsetLeft: number, startOffsetTop: number, offsetX: number, offsetY: number, dataInfo: any) => {
  const left = startOffsetLeft + offsetX;
  const top = startOffsetTop + offsetY;
  let width = 0;
  let height = 0;
  let newLeft = left;
  let newTop = top;
  let ratio = 0;

  if (isNaN(left) || isNaN(top)) {
    console.log("resize invalid");
    return;
  }

  if (direction.includes("top")) {
    height = startHeight - offsetY;
  } else {
    height = startHeight + (direction.includes("bottom") ? offsetY : 0);
    newTop = startOffsetTop;
  }
  if (direction.includes("left")) {
    width = startWidth - offsetX;
  } else {
    width = startWidth + (direction.includes("right") ? offsetX : 0);
    newLeft = startOffsetLeft;
  }
  // to avoid unexpected ratio or min size later
  if (height < dataInfo.minHeight) {
    // console.log("top min")
    height = dataInfo.minHeight;
  }
  if (width < dataInfo.minWidth) {
    // console.log("left min")
    width = dataInfo.minWidth;
  }

  ratio = getComponentRatio(dataInfo.type, startHeight, startWidth, height, width);
  if (ratio && direction.includes("-")) {
    const temp = width * ratio;

    if (Math.abs(height / width) >= ratio) {
      if (dataInfo.type === "WIDGET_QR_CODE") {
        if (dataInfo.data.titleSwitch) {
          height = temp < dataInfo.minHeight? dataInfo.minHeight : temp;
        } else {
          height = width * ratio;
        }
      } else if (dataInfo.type === "WIDGET_TIMETABLE") {
        if (dataInfo.data.listTitleShow) {
          height = temp < dataInfo.minHeight? dataInfo.minHeight : temp;
        } else {
          height = temp < dataInfo.minHeight? dataInfo.minHeight : temp;
        }
      } else {
        height = width * ratio;
      }
      if (height < dataInfo.minHeight)
        height = dataInfo.minHeight;
    } else {
      if (dataInfo.type === "WIDGET_QR_CODE") {
        if (dataInfo.data.titleSwitch) {
          height = temp < dataInfo.minHeight? dataInfo.minHeight : temp;
          width = height / ratio;
        } else {
          width = height / ratio;
        }
      } else if (dataInfo.type === "WIDGET_TIMETABLE") {
        if (dataInfo.data.listTitleShow) {
          height = temp < dataInfo.minHeight? dataInfo.minHeight : temp;
        } else {
          height = temp < dataInfo.minHeight? dataInfo.minHeight : temp;
        }
      } else {
        width = height / ratio;
      }
      if (width < dataInfo.minWidth)
        width = dataInfo.minWidth;
    }
  }
  if (direction.includes("top") || direction.includes("left")) {
    if (direction.includes("top")) newTop = startOffsetTop - height + startHeight;
    if (direction.includes("left")) newLeft = startOffsetLeft - width + startWidth;
  }

  return {
    width: width,
    height: height,
    newLeft: newLeft,
    newTop: newTop,
  };
}

export const dragMouseDown = (e: any, position: any, holdThisBox: any, popupRef: any, onUpdate: any, scale: any, id: any, target: any, username: any, actionEnd: any, canDrag: boolean, handleAction?: any) => {
  if (username && target.studentName !== username) return;
  if (!popupRef.current) return;
  if (target.onLock) return;
  if (target.spotlight) return;
  if (!canDrag) return;
  if (e.target.closest('[data-interaction-ignore-drag="true"]') && e.target.closest('[data-interaction-ignore-drag="true"]').getAttribute('data-interaction-ignore-drag')) return;
  if (e.target.closest('[data-interaction-target-type="false"]') && e.target.closest('[data-interaction-target-type="false"]').getAttribute('data-interaction-target-type')) return;

  RESIZE_ACTION = true;
  if (holdThisBox) {
    holdThisBox(true);
  }

  const screenBg = document.querySelector('.screen-bg');

  const startX = e.clientX || e.pageX || (e.touches && e.touches[0].clientX)
  const startY = e.clientY || e.pageY || (e.touches && e.touches[0].clientY)
  const startOffsetLeft = popupRef.current.offsetLeft;
  const startOffsetTop = popupRef.current.offsetTop;

  const dragEnd = (e: any) => {
    RESIZE_ACTION = false;
    if (holdThisBox) {
      holdThisBox(false);
    }

    screenBg?.classList.remove('bg-hide');
    if (id !== "") {
      actionEnd(true);
    }
  
    if (handleAction) {
      const { onSelect, setSideDrag } = handleAction;
        onSelect(e, id);
        setSideDrag(false);
    }

    document.onpointerup = null;
    document.onpointermove = null;
    document.onmouseup = null;
    document.onmousemove = null;
    document.ontouchend = null;
    document.ontouchmove = null;
  };

  const dragMove = (e: any) => {
    if (!RESIZE_ACTION) return;
    if (holdThisBox) {
      holdThisBox(true);
    }

    screenBg?.classList.add('bg-hide');

    const newMouseX = (e.clientX || e.pageX || (e.touches && e.touches[0].clientX)) ?? 0;
    const newMouseY = (e.clientY || e.pageY || (e.touches && e.touches[0].clientY)) ?? 0;

    const offsetX = newMouseX - startX;
    const offsetY = newMouseY - startY;
    const left = startOffsetLeft + offsetX;
    const top = startOffsetTop + offsetY;
    position({ x: left, y: top });
    onUpdate({ id: id, left: left, top: top });
  };

  document.onpointerup = dragEnd;
  document.onpointermove = dragMove;
  document.onmouseup = dragEnd;
  document.onmousemove = dragMove;
  document.ontouchend = dragEnd;
  document.ontouchmove = dragMove;
};

export const resizeMouseDown = (e: any, direction: "top" | "right" | "bottom" | "left" | "top-left" | "top-right" | "bottom-right" | "bottom-left", sideWidget: any, minSize: any, size: any, position: any, holdThisBox: any, popupRef: any, onUpdate: any, scale: any, id: any, target: any, username: any, actionEnd: any) => {
  // console.log(e);

  if (username && target.studentName !== username) return;
  if (!popupRef.current) return;
  if (target.onLock) return;
  if (target.spotlight) return;
  if (!sideWidget && (direction === "top" || direction === "right" || direction === "bottom" || direction === "left")) return;

  RESIZE_ACTION = true;
  holdThisBox(true);

  const Box = popupRef.current.getBoundingClientRect();
  const startX = e.clientX || e.pageX || (e.touches && e.touches[0].clientX);
  const startY = e.clientY || e.pageY || (e.touches && e.touches[0].clientY);
  const startWidth = popupRef.current.offsetWidth;
  const startHeight = popupRef.current.offsetHeight;
  const startOffsetLeft = popupRef.current.offsetLeft;
  const startOffsetTop = popupRef.current.offsetTop;
  const minOffsetLeft = popupRef.current.offsetLeft + (Box.width - minSize.minWidth);
  const minOffsetTop = popupRef.current.offsetTop + (Box.height - minSize.minHeight);
  const screenBg = document.querySelector('.screen-bg');
  // console.log('start', startWidth + startOffsetLeft , startHeight + startOffsetTop)

  const resizeEnd = () => {
    RESIZE_ACTION = false;
    holdThisBox(false);

    screenBg?.classList.remove('bg-hide');
    if (id !== "") {
      actionEnd(true);
    }

    document.onpointerup = null;
    document.onpointermove = null;
    document.onmouseup = null;
    document.onmousemove = null;
    document.ontouchend = null;
    document.ontouchmove = null;
  };

  const resizeMove = (e: any) => {
    if (!RESIZE_ACTION) return;
    holdThisBox(true);

    screenBg?.classList.add('bg-hide');

    const newMouseX = (e.clientX || e.pageX || (e.touches && e.touches[0].clientX)) ?? 0;
    const newMouseY = (e.clientY || e.pageY || (e.touches && e.touches[0].clientY)) ?? 0;
    const offsetX = newMouseX - startX;
    const offsetY = newMouseY - startY;

    const resizeResult = resizeCalculate(direction, startWidth, startHeight, startOffsetLeft, startOffsetTop, offsetX, offsetY, {
      minHeight: minSize.minHeight,
      minWidth: minSize.minWidth,
      ...target
    });

    if (resizeResult) {
      if (direction.includes("top") || direction.includes("left")) {
        position({ x: resizeResult.newLeft, y: resizeResult.newTop });
        onUpdate({ id: id, left: resizeResult.newLeft, top: resizeResult.newTop });
      }

      setSize({ width: resizeResult.width, height: resizeResult.height });
    }
  };

  document.onpointerup = resizeEnd;
  document.onpointermove = resizeMove;
  document.onmouseup = resizeEnd;
  document.onmousemove = resizeMove;
  document.ontouchend = resizeEnd;
  document.ontouchmove = resizeMove;

  const setSize = (data: any) => {
    const width = data.width < minSize.minWidth? minSize.minWidth : data.width;
    const height = data.height < minSize.minHeight? minSize.minHeight : data.height;
    popupRef.current.style.width = `${width}px`;
    popupRef.current.style.height = `${height}px`;
    size({ width: width, height: height });
  };

  // const scaleType = (type: any) => {
  //   if (excludeType.includes(type)) {
  //     return 1;
  //   } else {
  //     return scale;
  //   }
  // };
};

export const componentCheck =  (type: string) => {
  const toolList = [
    // "WIDGET_BACKGROUND",
    // "WIDGET_RANDOM_NAME",
    // "WIDGET_QR_CODE",
    // "WIDGET_IMAGE",
    "WIDGET_TEXT",
    "WIDGET_READ",
    "WIDGET_DRAW",
    // "WIDGET_TIMER",
    // "WIDGET_CLOCK",
    // "WIDGET_CALENDAR",
    "WIDGET_GROUP_MAKER",
    // "WIDGET_STOPWATCH",
    // "WIDGET_WEBCAM",
    // "WIDGET_VIDEO",
    // "WIDGET_EVENT_COUNTDOWN",
    // "WIDGET_HYPERLINK",
    "WIDGET_WORKS",
  ];
  if (toolList.includes(type)) {
    return false;
  } else {
    return true;
  }
  return true;
};

export const moveCheck =  (type: string) => {
  const toolList = [
    // "WIDGET_BACKGROUND",
    // "WIDGET_RANDOM_NAME",
    // "WIDGET_QR_CODE",
    // "WIDGET_IMAGE",
    "WIDGET_TEXT",
    "WIDGET_READ",
    "WIDGET_DRAW",
    // "WIDGET_TIMER",
    // "WIDGET_CLOCK",
    // "WIDGET_CALENDAR",
    "WIDGET_GROUP_MAKER",
    // "WIDGET_STOPWATCH",
    // "WIDGET_WEBCAM",
    "WIDGET_EMBED",
    "WIDGET_VIDEO",
    "WIDGET_VIDEO_TIMELINE",
    // "WIDGET_EVENT_COUNTDOWN",
    // "WIDGET_HYPERLINK",
    "WIDGET_WORKS",
    "WIDGET_MIND_MAP",
  ];
  if (toolList.includes(type)) {
    return true;
  } else {
    return false;
  }
};

export const hideCheck =  (type: string) => {
  const toolList = [
    "WIDGET_QR_CODE",
    "WIDGET_IMAGE",
    "WIDGET_TEXT",
    "WIDGET_READ",
    "WIDGET_CLOCK",
    "WIDGET_CALENDAR",
    "WIDGET_EVENT_COUNTDOWN",
    "WIDGET_HYPERLINK",
    "WIDGET_WORKS",
    // "WIDGET_MIND_MAP",
    "WIDGET_STROKES",
  ];
  if (toolList.includes(type)) {
    return true;
  } else {
    return false;
  }
};

export const toggleFullscreen = (setIsFullScreenMode: any) => {
  const document: any = window.document;
  document.body.classList.add("fullscreen-enable");

  if (
    !document.fullscreenElement &&
    !document.mozFullScreenElement &&
    !document.webkitFullscreenElement
  ) {
    // current working methods
    setIsFullScreenMode(false);
    if (document.documentElement.requestFullscreen) {
      document.documentElement.requestFullscreen();
    } else if (document.documentElement.mozRequestFullScreen) {
      document.documentElement.mozRequestFullScreen();
    } else if (document.documentElement.webkitRequestFullscreen) {
      document.documentElement.webkitRequestFullscreen();
    }
  } else {
    setIsFullScreenMode(true);
    if (document.cancelFullScreen) {
      document.cancelFullScreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitCancelFullScreen) {
      document.webkitCancelFullScreen();
    }
  }

  // handle fullscreen exit
  const exitHandler = () => {
    if (
      !document.webkitIsFullScreen &&
      !document.mozFullScreen &&
      !document.msFullscreenElement
    )
      document.body.classList.remove("fullscreen-enable");
  };
  document.addEventListener("fullscreenchange", exitHandler);
  document.addEventListener("webkitfullscreenchange", exitHandler);
  document.addEventListener("mozfullscreenchange", exitHandler);
};

export const getUrlParameter = (name: string) => {
  name = name.replace(/[\]]/, '');
  const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
  const results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

export const removeAuthTokenFromUrl = () => {
  const url = window.location.href;
  const parsedUrl = new URL(url);
  const searchParams = parsedUrl.searchParams;
  searchParams.delete('authtoken');
  const newUrl = `${parsedUrl.origin}${parsedUrl.pathname}?${searchParams.toString()}`;
  window.history.pushState({}, '', newUrl);
};

export const random = (count: number) => {
  const val = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z','a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z','0','1','2','3','4','5','9','7','8','9'];
  const max = val.length,
        min = 0;
  let random_code = '';
  for (let i = 0; i < count; i++) {
    let num = Math.floor(Math.random()*(max-min+1))+min;
    num = num >= max ? num -1 : num;
    random_code  = random_code + val[num];
  }
  return random_code;
  //
};

export const randomNumber = (count: number) => {
  const val = ['0','1','2','3','4','5','9','7','8','9'];
  const max = val.length,
        min = 0;
  let random_code = '';
  for (let i = 0; i < count; i++) {
    let num = Math.floor(Math.random()*(max-min+1))+min;
    num = num >= max ? num -1 : num;
    random_code  = random_code + val[num];
  }
  return random_code;
  //
};